// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yQ-z","inlineTitle":"zQ-z","sponsoredAdsWrapper":"AQ-z","marketplaceRecosWrapper":"BQ-z"};